import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full bg-gradient-to-b from-primary-50 via-background-50 to-background-50 pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 md:w-96 md:h-96 rounded-full bg-primary-100/70 blur-2xl"></div>
      <div className="absolute top-40 -left-20 w-64 h-64 rounded-full bg-accent-100/60 blur-2xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 font-label">
              <i className="ri-flashlight-line text-accent-600"></i>
              安卓 / iOS / 平板 全平台版本同步
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-foreground-950">
              漫蛙客户端下载
              <span className="block text-primary-700">想在哪看，就在哪下</span>
            </h1>

            <p className="mt-5 text-sm md:text-base leading-7 text-foreground-600 max-w-xl">
              这里汇总了漫蛙官网的 APP 下载入口，覆盖安卓版、iOS 版与最新版。无论你用的是手机还是平板，
              都能对照配置要求找到对应客户端，快速完成安装并开始看漫，不用再到处翻找下载地址。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3 sm:items-center">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-line text-lg"></i>
                安卓版下载
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 版下载
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-3 md:gap-5 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label} className="rounded-lg bg-background-100/80 border border-background-200 px-3 py-3">
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-label text-sm md:text-base font-medium text-foreground-950">{stat.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="order-1 lg:order-2 w-full">
            <div className="relative w-full max-w-md mx-auto lg:max-w-none rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <div className="w-full h-[320px] sm:h-[420px] lg:h-[520px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20mobile%20phone%20mockup%20showing%20a%20colorful%20comic%20reading%20app%20interface%20with%20panel%20grid%2C%20soft%20cream%20beige%20studio%20background%20with%20gentle%20green%20leaf%20shapes%2C%20clean%20minimal%20product%20photography%2C%20friendly%20modern%20aesthetic%2C%20soft%20diffused%20natural%20lighting%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=1100&seq=manwa-hero-01&orientation=portrait"
                  alt="漫蛙漫画阅读客户端界面示意"
                  title="漫蛙客户端界面"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-lg bg-background-50/95 border border-background-200 px-4 py-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                </span>
                <p className="text-xs md:text-sm text-foreground-700">
                  版本信息与配置要求持续同步，安装前可先核对设备是否适配。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}